import { createContext } from "react";

import type { AuthContextInterface } from "~/features/auth/contexts/AuthContext/authContextTypes.ts";

const AuthContext = createContext<AuthContextInterface | null>(null);

export default AuthContext;
